import type { GridSpanCountFilter } from "@/client/types/filters";
import { Box, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import type { FilterRenderProps } from "../../grid/CompGrid";

export interface GridSpanCountFilterPopoverProps extends FilterRenderProps {
    label?: string;
  }
  
  export function GridSpanCountFilterPopover({
    value,
    onChange,
    label = "Spans",
  }: GridSpanCountFilterPopoverProps) {
    const d = value as GridSpanCountFilter | undefined;
    const min = d?.min ?? null;
    const max = d?.max ?? null;
  
    const [minInput, setMinInput] = useState(min != null ? String(min) : "");
    const [maxInput, setMaxInput] = useState(max != null ? String(max) : "");
  
    useEffect(() => {
      setMinInput(min != null ? String(min) : "");
    }, [min]);
    useEffect(() => {
      setMaxInput(max != null ? String(max) : "");
    }, [max]);
  
    const applyMin = () => {
      const parsed = Number(minInput);
      onChange({ min: parsed, max: max ?? null });
    };
    const applyMax = () => {
      const parsed = Number(maxInput);
      onChange({ min: min ?? null, max: parsed });
    };
  
    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, minWidth: 200 }}>
        <TextField
          size="small"
          label={`${label} min`}
          placeholder="Min"
          value={minInput}
          onChange={(e) => setMinInput(e.target.value)}
          onBlur={applyMin}
          onKeyDown={(e) => e.key === "Enter" && applyMin()}
        />
        <TextField
          size="small"
          label={`${label} max`}
          placeholder="Max"
          value={maxInput}
          onChange={(e) => setMaxInput(e.target.value)}
          onBlur={applyMax}
          onKeyDown={(e) => e.key === "Enter" && applyMax()}
        />
      </Box>
    );
  }